import Vue from 'vue'
import Router from 'vue-router'


import GateWayIndex from "@/views/index.vue";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
    // mode: "hash",
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: "/",
            redirect: "/index",
            meta: { keepAlive: true }
        },
        {
            path: "/GateWayIndex",
            component: GateWayIndex,
            hidden: true,
            children: [
                // 首页
                {
                    path: "/index",
                    name: "index",
                    // component: () => import("@/views/indexPage/index.vue"),
                    component: () => import("@/views/home"),
                    meta: { keepAlive: true }
                },
                // 金融产品
                {
                    path: "/financeProject",
                    name: "financeProject",
                    component: () => import('@/views/products/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/products',
                            name: "products",
                            component: () => import('@/views/products/financity-products-list'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/productsDetails',
                            name: 'productsDetails',
                            component: () => import('@/views/products/financity-products-details'),
                            meta: { keepAlive: false, activeMenu: 'products' }
                        },
                    ]
                },
                // 融资增信
                {
                    path: "/financeCredit",
                    name: "financeCredit",
                    component: () => import('@/views/service/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/service',
                            name: "service",
                            component: () => import('@/views/service/financity-service-list'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/serviceDetails',
                            name: 'serviceDetails',
                            component: () => import('@/views/service/financity-service-details'),
                            meta: { keepAlive: false, activeMenu: 'service' }
                        },
                    ]
                },
                // 投资理财
                {
                    path: "/investmentMoney",
                    name: "investmentMoney",
                    component: () => import('@/views/investment/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/investment',
                            name: "investment",
                            component: () => import('@/views/investment/index'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/investmentDetails',
                            name: 'investmentDetails',
                            component: () => import('@/views/investment/details'),
                            meta: { keepAlive: false, activeMenu: 'investment' }
                        },
                    ]
                },
                // 金融机构
                {
                    path: "/financeOrg",
                    name: "financeOrg",
                    component: () => import('@/views/financialOrg/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/productsOrg',
                            name: "productsOrg",
                            component: () => import('@/views/financialOrg/financity-org-list'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/orgDetails',
                            name: 'orgDetails',
                            component: () => import('@/views/financialOrg/financity-org-details'),
                            meta: { keepAlive: false, activeMenu: 'productsOrg' }
                        },
                    ]
                },
                // 金融调解
                {
                    path: "/mediation",
                    name: "mediation",
                    meta: { keepAlive: false, activeMenu: 'index' }
                },
                // 资产拍卖
                {
                    path: "/assetsSate",
                    name: "assetsSate",
                    component: () => import('@/views/assetsAuction/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/assetsAuction',
                            name: "assetsAuction",
                            component: () => import('@/views/assetsAuction/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/assetsAuctionDetail/:auctionId',
                            name: 'assetsAuctionDetail',
                            component: () => import('@/views/assetsAuction/detail'),
                            meta: { keepAlive: false, activeMenu: 'assetsAuction' }
                        },
                        {
                            path: '/assetsAuctionBM/:auctionId',
                            name: 'assetsAuctionBM',
                            component: () => import('@/views/assetsAuction/baoming'),
                            meta: { keepAlive: false, activeMenu: 'assetsAuction' }
                        },
                    ]
                },
                // 资产拍卖
                {
                    path: "/assetsSate2",
                    name: "assetsSate2",
                    component: () => import('@/views/assetsAuction2/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/assetsAuction2',
                            name: "assetsAuction2",
                            component: () => import('@/views/assetsAuction2/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/assetsAuctionDetail2/:auctionId',
                            name: 'assetsAuctionDetail2',
                            component: () => import('@/views/assetsAuction2/detail'),
                            meta: { keepAlive: false, activeMenu: 'assetsAuction2' }
                        },
                        {
                            path: '/assetsAuctionBM2/:auctionId',
                            name: 'assetsAuctionBM2',
                            component: () => import('@/views/assetsAuction2/baoming'),
                            meta: { keepAlive: false, activeMenu: 'assetsAuction2' }
                        },
                    ]
                },
                // 政策动态
                {
                    path: "/policyTrends",
                    name: "policyTrends",
                    component: () => import('@/views/information/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/information',
                            name: "information",
                            component: () => import('@/views/information/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/informationDetail',
                            name: 'informationDetail',
                            component: () => import('@/views/information/detail'),
                            meta: { keepAlive: false, activeMenu: 'information' }
                        },
                    ]
                },
                // 政策支持
                {
                    path: "/policyAssist",
                    name: "policyAssist",
                    component: () => import('@/views/policySupport/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/policySupport',
                            name: "policySupport",
                            component: () => import('@/views/policySupport/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/supportDetail',
                            name: 'supportDetail',
                            component: () => import('@/views/information/support-detail'),
                            meta: { keepAlive: false, activeMenu: 'policySupport' }
                        },
                        {
                            path: '/policyMatchList',
                            name: 'policyMatchList',
                            component: () => import('@/views/policyMatchList/index'),
                            meta: { keepAlive: false, activeMenu: 'policySupport' }
                        },
                    ]
                },
                // 农情信息 - 农资信息
                {
                    path: "/farmerMoneyInfo",
                    name: "farmerMoneyInfo",
                    component: () => import('@/views/agriculturalInfo/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/agriculturalList',
                            name: "agriculturalList",
                            component: () => import('@/views/agriculturalInfo/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/agriculturalDetail/:infoId',
                            name: "agriculturalDetail",
                            component: () => import('@/views/agriculturalInfo/detail.vue'),
                            meta: { keepAlive: false }
                        },
                    ]
                },
                // 农情信息 - 农情信息
                {
                    path: "/farmerFeelInfo",
                    name: "farmerFeelInfo",
                    component: () => import('@/views/agriEmind/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/agriEmind',
                            name: "agriEmind",
                            component: () => import('@/views/agriEmind/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/agriEmindDetail',
                            name: "agriEmindDetail",
                            component: () => import('@/views/agriEmind/detail.vue'),
                            meta: { keepAlive: false }
                        },
                    ]
                },
                // 综合服务 - 项目合作
                {
                    path: "/projectCooperate",
                    name: "projectCooperate",
                    component: () => import('@/views/projectInteract/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/projectInteract',
                            name: "projectInteract",
                            component: () => import('@/views/projectInteract/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/projectInteractDetail/:infoId',
                            name: "projectInteractDetail",
                            component: () => import('@/views/projectInteract/detail.vue'),
                            meta: { keepAlive: false }
                        },
                    ]
                },
                // 综合服务 - 服务推荐
                {
                    path: "/serviceRecommend",
                    name: "serviceRecommend",
                    component: () => import('@/views/serviceRecommend/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/serviceRecommend',
                            name: "serviceRecommend",
                            component: () => import('@/views/serviceRecommend/index.vue'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/serviceRecommendDetail',
                            name: "serviceRecommendDetail",
                            component: () => import('@/views/serviceRecommend/detail.vue'),
                            meta: { keepAlive: false }
                        },
                    ]
                },
                // 关于我们
                {
                    path: "/aboutus",
                    name: "aboutus",
                    component: () => import("@/views/aboutus/aboutus"),
                    meta: { keepAlive: false }
                },
                // 帮助中心
                {
                    path: '/helpCenter',
                    name: 'helpCenter',
                    component: () => import('@/views/helpCenter/index'),
                    meta: { keepAlive: false, activeMenu: 'index' }
                },
                // headLoan
                {
                    path: "/headLoanMain",
                    name: "headLoanMain",
                    component: () => import('@/views/headLoan/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/headLoanList',
                            name: "headLoanList",
                            component: () => import('@/views/headLoan/headLoan-list'),
                            meta: { keepAlive: false }
                        },
                        {
                            path: '/headLoanDetails',
                            name: "headLoanDetails",
                            component: () => import('@/views/headLoan/headLoan-details'),
                            meta: { keepAlive: false }
                        },
                    ]
                },
                // 文件调查
                {
                    path: "/questionnaireMain",
                    name: "questionnaireMain",
                    component: () => import('@/views/questionnaire/main.vue'),
                    meta: { keepAlive: false },
                    children: [
                        {
                            path: '/questionnaire',
                            name: "questionnaire",
                            component: () => import('@/views/questionnaire/index'),
                            meta: { keepAlive: false, activeMenu: 'index' }
                        },
                        {
                            path: '/testPaper',
                            name: "testPaper",
                            component: () => import('@/views/questionnaire/testPaper'),
                            meta: { keepAlive: false, activeMenu: 'index' }
                        },
                    ]
                },
                // 拍卖指南
                {
                  path: '/auctionGuide',
                  name: 'auctionGuide',
                  component: () => import('@/views/auctionGuide/index'),
                  meta: { keepAlive: false, activeMenu: 'index' }
              },
            ]
        },



        // {
        //     path: '/declareList',
        //     name: 'declareList',
        //     component: () => import('@/views/policySupport/allDeclare')
        // },
        // {
        //     path: '/statistics',
        //     name: 'statistics',
        //     component: () => import('@/views/statistics')
        // },
        // {
        //     path: '/financityDetails',
        //     name: 'financityDetails',
        //     component: () => import('@/views/products/financity-details')
        // },
        // {
        //     path: '/fianceEvaluation',
        //     name: 'fianceEvaluation',
        //     component: () => import('@/views/fianceEvaluation/index')
        // },
        // {
        //     path: '/columnService',
        //     name: 'columnService',
        //     component: () => import('@/views/columnService/index')
        // },
        // {
        //     path: '/silverindex',
        //     name: 'silverindex',
        //     component: () => import('@/views/columnService/silverindex')
        // },
        // {
        //     path: '/silverdetails',
        //     name: 'silverdetails',
        //     component: () => import('@/views/columnService/silverdetails')
        // },
        // {
        //     path: '/indexdetails',
        //     name: 'indexdetails',
        //     component: () => import('@/views/columnService/indexdetails')
        // },
        // {
        //     path: '/interactive',
        //     name: 'interactive',
        //     component: () => import('@/views/interactive/index')
        // },
        // {
        //     path: '/videodetails',
        //     name: 'videodetails',
        //     component: () => import('@/views/interactive/videodetails')
        // },
        // {
        //     path: '/columnFirstLoan',
        //     name: 'columnFirstLoan',
        //     // component: () => import('@/views/columnFirstLoan/index')
        //     component: () => import('@/views/columnFirstLoan/firstLoanDescribe')
        // },
        // {
        //     path: '/columnCredit',
        //     name: 'columnCredit',
        //     component: () => import('@/views/columnCredit/index')
        // },
        // {
        //     path: '/columnVia',
        //     name: 'columnVia',
        //     component: () => import('@/views/columnVia/index')
        // },
        // {
        //     path: '/columnBreed',
        //     name: 'columnBreed',
        //     component: () => import('@/views/columnBreed/index')
        // },
        // {
        //     path: '/seeAllVIa',
        //     name: 'seeAllVIa',
        //     component: () => import('@/views/columnVia/seeAllVIa')
        // },
        // {
        //     path: '/columnFirstLoanList',
        //     name: 'columnFirstLoanList',
        //     component: () => import('@/views/columnFirstLoan/firstLoanList')
        // },
        // {
        //     path: '/firstloandetail',
        //     name: 'firstloandetail',
        //     component: () => import('@/views/columnFirstLoan/firstloandetail')
        // },
        // {
        //     path: '/columnIndex',
        //     name: 'columnIndex',
        //     component: () => import('@/views/columnService/columnIndex')
        // },
        // {
        //     path: '/indexPolicy',
        //     name: 'indexPolicy',
        //     component: () => import('@/views/columnPolicySubsidy/indexPolicy')
        // },
        // {
        //     path: '/indexLoan',
        //     name: 'indexLoan',
        //     component: () => import('@/views/columnLoanRenewal/indexLoan')
        // },
        // // 五位一体

        // {
        //     path: '/InformationCollection',
        //     name: 'InformationCollection',
        //     component: () => import('@/views/fiveInOne/InformationCollection')
        // },
        // {
        //     path: '/FinancingCredit',
        //     name: 'FinancingCredit',
        //     component: () => import('@/views/fiveInOne/FinancingCredit')
        // },
        // {
        //     path: '/FinancingDock',
        //     name: 'FinancingDock',
        //     component: () => import('@/views/fiveInOne/FinancingDock')
        // },
        // {
        //     path: '/PolicySupport',
        //     name: 'PolicySupport',
        //     component: () => import('@/views/fiveInOne/PolicySupport')
        // },
        // {
        //     path: '/FinancingEvaluate',
        //     name: 'FinancingEvaluate',
        //     component: () => import('@/views/fiveInOne/FinancingEvaluate')
        // },
        // {
        //     path: '/upgrade',
        //     name: 'upgrade',
        //     component: () => import('@/views/upgrade')
        // },
    ]
});

router.beforeEach(async (to, from, next) => {
    if (to.path.indexOf('mediation') !== -1) {
        next('/')
        let userInfoObj = JSON.parse(window.sessionStorage.getItem("userInfo"));
        // if(userInfoObj==null){
        //     window.open('https://lzt.rjhc.tech', '_blank');
        // }else{
        //     if(userInfoObj.userType==1){
        //         window.open('https://lzt.rjhc.tech?u='+userInfoObj.userName, '_blank');
        //     }else{
        //         window.open('https://lzt.rjhc.tech', '_blank');
        //     }
        // }
        window.open('https://www.fcosc.org.cn/', '_blank');
       
    } else {
        next();
    }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js